export const SEO_GAME_CATALOG = [
  {
    id: 'shapes_sorting',
    name: 'Figūrų rūšiavimas',
    icon: '🔷',
    skill: 'Formos ir loginis mąstymas',
    categories: ['educational'],
    slug: 'figuru-rusiavimas',
    topics: ["Formos","Loginis mąstymas"],
  },
  {
    id: 'colors_matching',
    name: 'Spalvų derinimas',
    icon: '🎨',
    skill: 'Spalvų pažinimas ir dėmesys',
    categories: ['educational'],
    slug: 'spalvu-derinimas',
    topics: ["Spalvos","Dėmesys"],
  },
  {
    id: 'number_matching',
    name: 'Skaičių atitikimas',
    icon: '🔢',
    skill: 'Skaičių pažinimas ir skaičiavimas',
    categories: ['educational', 'math'],
    slug: 'skaiciu-atitikimas',
    topics: ["Skaičiai ir skaičiavimas"],
  },
  {
    id: 'word_builder',
    name: 'Žodžių sudarymas',
    icon: '📝',
    skill: 'Žodynas ir kalba',
    categories: ['educational', 'reading', 'lithuanian'],
    slug: 'zodziu-sudarymas',
    topics: ["Žodžių sudarymas","Žodynas"],
  },
  {
    id: 'sequence_builder',
    name: 'Sekos kūrimas',
    icon: '🔢',
    skill: 'Dėsningumai ir loginis mąstymas',
    categories: ['educational', 'math'],
    slug: 'sekos-kurimas',
    topics: ["Skaičiai ir skaičiavimas","Loginis mąstymas"],
  },
  {
    id: 'pattern_matching',
    name: 'Šablonų derinimas',
    icon: '🧩',
    skill: 'Loginis mąstymas',
    categories: ['educational'],
    slug: 'sablonu-derinimas',
    topics: ["Loginis mąstymas","Dėsningumai"],
  },
  {
    id: 'story_sequence',
    name: 'Pasakojimo seka',
    icon: '📖',
    skill: 'Skaitymas ir teksto supratimas',
    categories: ['educational', 'reading'],
    slug: 'pasakojimo-seka',
    topics: ["Pasakojimo seka","Teksto supratimas"],
  },
  {
    id: 'math_equation',
    name: 'Matematinės lygtys',
    icon: '➕',
    skill: 'Lygčių sprendimas',
    categories: ['educational', 'math'],
    slug: 'matematines-lygtys',
    topics: ["Matematinės lygtys"],
  },
  {
    id: 'number_line_jump',
    name: 'Šokinėjimas ant skaičių tiesės',
    icon: '🦘',
    skill: 'Skaičių tiesė ir skaičiavimas',
    categories: ['educational', 'math'],
    slug: 'sokinejimas-ant-skaiciu-tieses',
    topics: ["Skaičiai ir skaičiavimas"],
  },
  {
    id: 'fraction_pizza',
    name: 'Trupmenos su Pica',
    icon: '🍕',
    skill: 'Trupmenos',
    categories: ['math'],
    slug: 'trupmenos-su-pica',
    topics: ["Trupmenos"],
  },
  {
    id: 'math_bingo',
    name: 'Matematikos Bingo',
    icon: '🎲',
    skill: 'Skaičiavimas',
    categories: ['math'],
    slug: 'matematikos-bingo',
    topics: ["Skaičiai ir skaičiavimas"],
  },
  {
    id: 'money_shop',
    name: 'Pinigų Parduotuvė',
    icon: '💰',
    skill: 'Pinigai ir skaičiavimas',
    categories: ['math'],
    slug: 'pinigine-parduotuve',
    topics: ["Pinigai"],
  },
  {
    id: 'time_clock',
    name: 'Laikrodžio Meistras',
    icon: '⏰',
    skill: 'Laiko pažinimas',
    categories: ['math'],
    slug: 'laikrodzio-meistras',
    topics: ["Laikas"],
  },
  {
    id: 'geometry_builder',
    name: 'Geometrijos Statytojas',
    icon: '📐',
    skill: 'Geometrija',
    categories: ['math'],
    slug: 'geometrijos-statytojas',
    topics: ["Geometrija"],
  },
  {
    id: 'chart_maker',
    name: 'Grafikų Kūrėjas',
    icon: '📊',
    skill: 'Grafikai ir duomenys',
    categories: ['math'],
    slug: 'grafiku-kurejas',
    topics: ["Grafikai"],
  },
  {
    id: 'multiplication_race',
    name: 'Daugybos Lenktynės',
    icon: '🏁',
    skill: 'Daugybos lentelė',
    categories: ['math'],
    slug: 'daugybos-lenktynes',
    topics: ["Daugyba"],
  },
  {
    id: 'alphabet_adventure',
    name: 'Abėcėlės Nuotykis',
    icon: '🔤',
    skill: 'Raidžių ir abėcėlės pažinimas',
    categories: ['educational', 'reading', 'lithuanian'],
    slug: 'abeceles-nuotykis',
    topics: ["Abėcėlė ir raidės"],
  },
  {
    id: 'syllable_sorter',
    name: 'Skiemenų Rūšiuotojas',
    icon: '🎵',
    skill: 'Skiemuo ir žodžio struktūra',
    categories: ['reading', 'lithuanian', 'speech'],
    slug: 'skiemenu-rusiuotojas',
    topics: ["Skiemenys"],
  },
  {
    id: 'rhyme_time',
    name: 'Rimų Laikas',
    icon: '🎤',
    skill: 'Rimai ir žodynas',
    categories: ['lithuanian', 'reading'],
    slug: 'rimu-laikas',
    topics: ["Žodynas","Rimai"],
  },
  {
    id: 'sentence_builder',
    name: 'Sakinių Sudarymas',
    icon: '🏗️',
    skill: 'Sakinių sudarymas',
    categories: ['reading', 'lithuanian'],
    slug: 'sakiniu-sudarymas',
    topics: ["Sakinių sudarymas"],
  },
  {
    id: 'vowel_consonant',
    name: 'Balsės vs Priebalsės',
    icon: '🔤',
    skill: 'Balsės ir priebalsės',
    categories: ['reading', 'lithuanian'],
    slug: 'balses-vs-priebalses',
    topics: ["Balsės ir priebalsės"],
  },
  {
    id: 'story_scramble',
    name: 'Pasakos Sudėliojimas',
    icon: '📚',
    skill: 'Pasakojimo struktūra',
    categories: ['reading'],
    slug: 'pasakos-sudeliojimas',
    topics: ["Pasakojimo seka"],
  },
  {
    id: 'word_family_tree',
    name: 'Žodžių Šeimos Medis',
    icon: '🌳',
    skill: 'Žodžių ryšiai ir žodynas',
    categories: ['reading', 'lithuanian'],
    slug: 'zodziu-seimos-medis',
    topics: ["Žodynas","Žodžių ryšiai"],
  },
  {
    id: 'capital_letter_detective',
    name: 'Didžiųjų Raidžių Detektyvas',
    icon: '🔎',
    skill: 'Rašyba ir didžiosios raidės',
    categories: ['lithuanian'],
    slug: 'didziuju-raidziu-detektyvas',
    topics: ["Didžiosios raidės"],
  },
  {
    id: 'sound_safari',
    name: 'Garsų Safari',
    icon: '👂',
    skill: 'Garsų atpažinimas',
    categories: ['speech'],
    slug: 'garsu-safari',
    topics: ["Kalbos garsai"],
  },
  {
    id: 'tongue_twister_challenge',
    name: 'Žodžių Laužiklių Iššūkis',
    icon: '👅',
    skill: 'Kalbos raiška',
    categories: ['speech', 'lithuanian'],
    slug: 'zodziu-lauzykliu-issukis',
    topics: ["Kalbos raiška"],
  },
  {
    id: 'minimal_pairs_memory',
    name: 'Minimalių Porų Atmintis',
    icon: '👂',
    skill: 'Panašių garsų skyrimas',
    categories: ['speech'],
    slug: 'minimaliu-poru-atmintis',
    topics: ["Minimalios poros","Kalbos garsai"],
  },
  {
    id: 'breathing_dragon',
    name: 'Kvėpuojantis Drakonas',
    icon: '🐉',
    skill: 'Kvėpavimo ir dėmesio pratimas',
    categories: ['speech'],
    slug: 'kvepuojantis-drakonas',
    topics: ["Kalbos lavinimas","Dėmesys"],
  },
  {
    id: 'syllable_clap',
    name: 'Skiemenų Plojimas',
    icon: '👏',
    skill: 'Skiemenų atpažinimas',
    categories: ['speech'],
    slug: 'skiemenu-plojimas',
    topics: ["Skiemenys"],
  },
  {
    id: 'sound_position_finder',
    name: 'Garso Detektyvas',
    icon: '🎯',
    skill: 'Garso vietos žodyje atpažinimas',
    categories: ['speech'],
    slug: 'garso-detektyvas',
    topics: ["Garso vieta žodyje"],
  },
  {
    id: 'sight_word_bingo',
    name: 'Žodžių Bingo',
    icon: '🎲',
    skill: 'Žodžių atpažinimas',
    categories: ['reading', 'speech'],
    slug: 'zodziu-bingo',
    topics: ["Žodžių atpažinimas"],
  },
  {
    id: 'reading_comprehension',
    name: 'Pasakų Kelionė',
    icon: '📖',
    skill: 'Teksto supratimas',
    categories: ['reading'],
    slug: 'pasaku-kelione',
    topics: ["Teksto supratimas"],
  },
  {
    id: 'word_hunt',
    name: 'Žodžių Medžioklė',
    icon: '🔍',
    skill: 'Žodžių atpažinimas ir dėmesys',
    categories: ['reading', 'lithuanian'],
    slug: 'zodziu-medziokle',
    topics: ["Žodžių atpažinimas","Žodynas"],
  },
  {
    id: 'character_detective',
    name: 'Veikėjų Detektyvas',
    icon: '🕵️',
    skill: 'Teksto supratimas',
    categories: ['reading'],
    slug: 'veikeju-detektyvas',
    topics: ["Veikėjai","Teksto supratimas"],
  },
  {
    id: 'punctuation_police',
    name: 'Skyrybos Policija',
    icon: '🚨',
    skill: 'Skyryba',
    categories: ['lithuanian'],
    slug: 'skyrybos-policija',
    topics: ["Skyryba"],
  },
  {
    id: 'speed_reading_racer',
    name: 'Greito Skaitymo Lenktynės',
    icon: '⚡',
    skill: 'Skaitymo tempas',
    categories: ['reading'],
    slug: 'greito-skaitymo-lenktynes',
    topics: ["Skaitymo sklandumas"],
  },
  {
    id: 'story_math',
    name: 'Pasakų Matematika',
    icon: '📖',
    skill: 'Matematinis problemų sprendimas',
    categories: ['math', 'reading'],
    slug: 'pasaku-matematika',
    topics: ["Loginis mąstymas","Teksto supratimas"],
  },
  {
    id: 'word_number_puzzle',
    name: 'Žodžių ir Skaičių Galvosūkis',
    icon: '🧩',
    skill: 'Kalbos ir matematikos logika',
    categories: ['educational', 'math', 'reading'],
    slug: 'zodziu-ir-skaiciu-galvosukis',
    topics: ["Loginis mąstymas","Skaičiai ir skaičiavimas"],
  },
  {
    id: 'ai_story_cowriter',
    name: 'AI Pasakų Rašytojas',
    icon: '✍️',
    skill: 'Kūrybinis rašymas',
    categories: ['reading', 'lithuanian'],
    slug: 'ai-pasaku-rasytojas',
    topics: ["Kūrybinis rašymas","Pasakojimo kūrimas","Kūrybiškumas"],
  },
  {
    id: 'math_art',
    name: 'Matematikos Meno Kūrėjas',
    icon: '🎨',
    skill: 'Matematika ir kūryba',
    categories: ['math'],
    slug: 'matematikos-meno-kurejas',
    topics: ["Matematika","Kūrybiškumas"],
  },
  {
    id: 'science_lab',
    name: 'Virtuali Mokslo Laboratorija',
    icon: '🔬',
    skill: 'Gamtos mokslai',
    categories: ['educational'],
    slug: 'virtuali-mokslo-laboratorija',
    topics: ["Gamtos mokslai"],
  },
  {
    id: 'emotion_charades',
    name: 'Emocijų Charados',
    icon: '😊',
    skill: 'Emocijų pažinimas ir raiška',
    categories: ['educational'],
    slug: 'emociju-charados',
    topics: ["Emocijų pažinimas"],
  },
  {
    id: 'recipe_math_chef',
    name: 'Receptų Matematikos Šefas',
    icon: '👨‍🍳',
    skill: 'Praktinė matematika',
    categories: ['math'],
    slug: 'receptu-matematikos-sefas',
    topics: ["Pinigai","Praktinė matematika"],
  },
  {
    id: 'geography_treasure_hunt',
    name: 'Geografijos Lobių Medžioklė',
    icon: '🌍',
    skill: 'Geografija',
    categories: ['educational'],
    slug: 'geografijos-lobiu-medziokle',
    topics: ["Geografija"],
  },
  {
    id: 'animal_habitat',
    name: 'Gyvūnų Buveinės',
    icon: '🐾',
    skill: 'Gamta ir gyvūnai',
    categories: ['educational'],
    slug: 'gyvunu-buveines',
    topics: ["Gamta ir gyvūnai","Gamtos mokslai"],
  },
  {
    id: 'weather_station',
    name: 'Orų Stotis',
    icon: '🌦️',
    skill: 'Orai ir gamtos pažinimas',
    categories: ['educational'],
    slug: 'oru-stotis',
    topics: ["Gamtos mokslai","Orai"],
  },
  {
    id: 'rhythm_maker',
    name: 'Ritmo Kūrėjas',
    icon: '🥁',
    skill: 'Ritmas ir muzikinė klausa',
    categories: ['educational'],
    slug: 'ritmo-kurejas',
    topics: ["Ritmas","Muzika"],
  },
  {
    id: 'note_name',
    name: 'Natų Pavadinimai',
    icon: '🎵',
    skill: 'Muzikos pagrindai',
    categories: ['educational'],
    slug: 'natu-pavadinimai',
    topics: ["Muzikos pagrindai"],
  },
  {
    id: 'simon_says',
    name: 'Simonas Sako',
    icon: '🎯',
    skill: 'Klausymas ir dėmesys',
    categories: ['educational', 'speech'],
    slug: 'simonas-sako',
    topics: ["Klausymas","Dėmesys"],
  },
  {
    id: 'shape_yoga',
    name: 'Figūrų Joga',
    icon: '🧘',
    skill: 'Formos, judėjimas ir dėmesys',
    categories: ['educational'],
    slug: 'figuru-joga',
    topics: ["Formos","Dėmesys"],
  },
  {
    id: 'veterinarian_clinic',
    name: 'Veterinarijos Klinika',
    icon: '🐶',
    skill: 'Gyvūnai ir problemų sprendimas',
    categories: ['educational'],
    slug: 'veterinarijos-klinika',
    topics: ["Gyvūnai","Problemų sprendimas"],
  },
  {
    id: 'store_cashier',
    name: 'Parduotuvės Kasininkas',
    icon: '🛒',
    skill: 'Pinigai ir skaičiavimas',
    categories: ['math'],
    slug: 'parduotuves-kasininkas',
    topics: ["Pinigai","Skaičiavimas"],
  },
  {
    id: 'teacher_helper',
    name: 'Mokytojo Padėjėjas',
    icon: '👩‍🏫',
    skill: 'Mokymosi užduotys',
    categories: ['educational'],
    slug: 'mokytojo-padejejas',
    topics: ["Mokymosi užduotys"],
  },
  {
    id: 'time_travel_history',
    name: 'Laiko Kelionė per Istoriją',
    icon: '⏳',
    skill: 'Istorijos pažinimas',
    categories: ['educational'],
    slug: 'laiko-kelione-per-istorija',
    topics: ["Istorija"],
  },
  {
    id: 'ai_coding_blocks',
    name: 'AI Programavimo Blokai',
    icon: '💻',
    skill: 'Programavimo ir loginio mąstymo pagrindai',
    categories: ['educational'],
    slug: 'ai-programavimo-blokai',
    topics: ["Programavimas","Loginis mąstymas"],
  },
  {
    id: 'dream_builder',
    name: 'Svajonių Kūrėjas',
    icon: '🌟',
    skill: 'Kūrybiškumas ir vaizduotė',
    categories: ['educational'],
    slug: 'svajoniu-kurejas',
    topics: ["Kūrybiškumas","Vaizduotė"],
  },
  {
    id: 'mystery_math_detective',
    name: 'Paslapčių Matematikos Detektyvas',
    icon: '🕵️',
    skill: 'Loginis problemų sprendimas',
    categories: ['math'],
    slug: 'paslapciu-matematikos-detektyvas',
    topics: ["Loginis mąstymas","Matematika"],
  },
  {
    id: 'debate_arena',
    name: 'Debatų Arena',
    icon: '🎭',
    skill: 'Argumentavimas ir kalbos raiška',
    categories: ['lithuanian', 'educational'],
    slug: 'debatu-arena',
    topics: ["Argumentavimas","Kalbos raiška"],
  },
  {
    id: 'kuciu_stalas',
    name: 'Kūčių Stalas',
    icon: '🍽️',
    skill: 'Kultūra ir kasdienio gyvenimo pažinimas',
    categories: ['educational'],
    slug: 'kuciu-stalas',
    topics: ["Kultūra","Kasdienis gyvenimas"],
  },
];

export const getGamesByCategory = (category) =>
  SEO_GAME_CATALOG.filter((game) => game.categories.includes(category));

export const SEO_GAME_COUNT = SEO_GAME_CATALOG.length;
